import React from 'react'
const CustomLoader = ({classType}) => {
    return (
        <div className={classType} id="custom-preloader">
            <div className="gooey">
                <span className="dot"></span>
                <div className="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    )
}

export default CustomLoader